import { MERCHANT_CONSULT_PHONE } from '@hlj/hlj-constant'
import {
  isFlowerDessert,
  isHotelProperty,
  isStandard,
  isUltimate
} from '@merchant-backend/util'
import { getProTitle, isTelSaleCityMerchant } from '@util'
import { Carousel } from 'hljd'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import style from './style.module.less'

@inject('pageStore')
@observer
export default class extends Component {
  static defaultProps = {
    showBuy: true
  }

  getUseList = merchant_use_list => {
    if (isHotelProperty()) {
      return (
        <div className={style['usage-list']}>
          {[
            {
              id: 1,
              title: (
                <div>
                  诺丁山<br />艺术中心
                </div>
              ),
              img: '//qnm.hunliji.com/o_1dlgjg28qpokjq6q951ski1eguf.png'
            },
            {
              id: 2,
              title: (
                <div>
                  嘉宝丽<br />婚礼艺术中心
                </div>
              ),
              img: '//qnm.hunliji.com/o_1dlgjg28q6d3kguutp1l3eugjg.png'
            },
            {
              id: 3,
              title: (
                <div>
                  宝格丽雅<br />国际宴会中心
                </div>
              ),
              img: '//qnm.hunliji.com/o_1dlgjg28q19fg7rppuvsmdiieh.png'
            },
            {
              id: 4,
              title: (
                <div>
                  韩国格乐利雅<br />婚礼会所
                </div>
              ),
              img: '//qnm.hunliji.com/o_1dlgjg28qrfpos1tprls41nu3i.png'
            },
            {
              id: 5,
              title: '喜来登酒店',
              img: '//qnm.hunliji.com/o_1dlgjg28q14asufi60i17ouhguj.png'
            },
            {
              id: 6,
              title: '洲际酒店',
              img: '//qnm.hunliji.com/o_1dlgjg28qmun1hvu1l101kjf6f9k.png'
            },
            {
              id: 7,
              title: '万豪酒店',
              img: '//qnm.hunliji.com/o_1dlgjg28q1s0c13na1d4l1f0s1fi3l.png'
            }
          ].map(({ id, title, img }) => {
            return (
              <div key={id}>
                <img src={img} />
                <div className="use-title">{title}</div>
              </div>
            )
          })}
        </div>
      )
    }

    return merchant_use_list.map((list, index) => {
      return (
        <div className={style['usage-list']} key={index}>
          {list.map((img, i) => {
            return <img key={i} src={img.path} />
          })}
        </div>
      )
    })
  }

  render() {
    const _isUltimate = isUltimate()
    const _isStandard = isStandard()
    const merchant_use_list = toJS(this.props.pageStore.merchant_use_list)

    return (
      <div className={style.usage}>
        <h3>他们都在用{getProTitle()}</h3>
        <div className={style['carousel-wrap']}>
          <Carousel autoplay speed={5000} dots={false}>
            {this.getUseList(merchant_use_list)}
          </Carousel>

          {this.props.showBuy &&
            !_isUltimate &&
            !_isStandard && (
              <div className={style['order-box']}>
                <div>
                  <div
                    className={style['order-submit']}
                    onClick={this.props.onClick}
                  >
                    {!isTelSaleCityMerchant() && isFlowerDessert()
                      ? '立即咨询'
                      : '立即订购'}
                  </div>
                  <div className={style['order-phone']}>
                    咨询热线 {MERCHANT_CONSULT_PHONE}
                  </div>
                </div>
              </div>
            )}
        </div>
      </div>
    )
  }
}
